import { render, staticRenderFns } from "./GasInvoiceDetail.vue?vue&type=template&id=2a2021d8&"
import script from "./GasInvoiceDetail.vue?vue&type=script&lang=ts&"
export * from "./GasInvoiceDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports